import React from "react";
import AlbumWrapper from "components/AlbumWrapper";

export const App = () => {
  return <AlbumWrapper />;
};
